<mat-form-field class="full-width no-hint">
  <input #tableSearchBar type="text" matInput [placeholder]="'label.search_by_term' | translate : searchBy"
    (keydown)="$event.stopPropagation()" />
  <button *ngIf="searchValue" matIconSuffix mat-icon-button aria-label="Clear" class="clear-button" [@fadeInOut]
    (click)="clearSearch()">
    <i class="ri-close-line"></i>
  </button>
</mat-form-field>
